import { Button, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { urls } from "../../urls";
import { InviteNotice } from "./InviteNotice";

export const AlreadyAccepted = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <InviteNotice title={t("Invite already accepted?")}>
      <Text>
        {t("It seems like you have already accepted this invite")}
        . <br /> <br />
        {t("This means you can")}{" "}
        <Button
          color="blue.500"
          fontWeight={"bold"}
          variant="link"
          onClick={() => {
            navigate(urls.login);
          }}
        >
          {t("click here to log in")}
        </Button>{" "}
        {t("instead!")}
      </Text>
    </InviteNotice>
  );
};
